<template>
  <v-navigation-drawer
    v-model="sidebarState"
    temporary
    app
  >
    <v-list dense>
      <template  v-for="link in _links">
        <v-row
          v-if="link.heading"
          :key="link.heading"
          align="center"
        >
          <v-col cols="6">
            <v-subheader v-if="link.heading">
              {{ link.heading }}
            </v-subheader>
          </v-col>
          <v-col
            cols="6"
            class="text-center"
          >
            <a
              href="#!"
              class="body-2 black--text"
            >EDIT</a>
          </v-col>
        </v-row>
        <v-list-group
          v-else-if="link.children"
          :key="link.text"
          v-model="link.model"
          :prepend-icon="link.model ? link.icon : link['icon-alt']"
          append-icon=""
        >
          <template v-slot:activator>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item
            v-for="(child, i) in item.children"
            :key="i"
          >
            <v-list-item-action v-if="child.icon">
              <v-icon>{{ child.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ child.text }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-else
          :key="link.to"
          :to="{name: link.to}"
        >
          <v-list-item-action>
            <v-icon>{{ link.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ link.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'sidebar',
  data () {
    return {
    }
  },

  computed: {
    sidebarState: {
      get () {
        return this._sidebarState
      },
      set (value) {
        this._toggleSidebar(value)
      }
    },
    ...mapGetters('tradle', {
      _links: 'links',
      _sidebarState: 'sidebarState'
    })
  },

  methods: {
    ...mapActions('tradle', {
      _toggleSidebar: 'toggleSidebar'
    })
  }
}
</script>

<style scoped>

</style>
